import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addBlogEndpoint = ApiEndpoints.adminBlogs.blogCreate;
const authorListEndpoint = ApiEndpoints.autor.authorList;
const categoryListEndpoint = ApiEndpoints.category.categoryList;
const tagListEndpoint = ApiEndpoints.tags.tagList;
const userName = "Admin";

export default function AddBlogAdmin() {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [tags, setTags] = useState([]);

  const [previews, setPreviews] = useState({ section_image: null, image: null,});

  const [postData, setPostData] = useState({ category_id: "", author_id: "", tag1: "", name: "", slug: "", description1: "", quote: "",  description2: "", designation:"",  section_image: null, image: null, createdBy: userName, date:"",});

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        setCategories(response?.blog_categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategories([]);
      }
    };

    const fetchAuthors = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        setAuthors(response?.authors || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setAuthors([]);
      }
    };

    const fetchTags = async () => {
      try {
        const response = await ApiRequest("GET", tagListEndpoint);
        setTags(response?.tags || []);
      } catch (error) {
        console.error("Failed to fetch tags:", error);
        setTags([]);
      }
    };

    fetchCategories();
    fetchAuthors();
    fetchTags();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
    if (files) {
      const file = files[0];  
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));
  
      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file, 
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
 
  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (key !== "brief" && key!=="quote" && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", addBlogEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/blog");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

    const pagename = {
      name: 'Blog Management',
      user: 'Admin',
      innerpage: 'Blog Management / Blog / Add Blog'
    }

  return (
    <>
      <AdminHeader pagename={pagename}/>
       <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="name" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small> (add prefix "blog-" in slug)</label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"category_id"} options={categories} placeholder="Select Category" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Date " />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="author_id" options={authors} placeholder="Select Author Name" />
                </div>
              </div>

               <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Designation<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="designation"  className="form-control" placeholder="Designation" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Tag Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="tag1" options={tags} placeholder="Select Tag Name" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> First Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description1} onChange={(event, editor) => handleEditorChange("description1", editor.getData())}/>
                </div>
              </div>
            </div>
          </div>


           <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Quote <small></small></label>
                  </div>
               <input value={postData.quote} onChange={handleChange} name="quote" type="text" className="form-control" placeholder="Enter Quote" />
                </div>
              </div>
            </div>
          </div>


          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Second Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description2} onChange={(event, editor) => handleEditorChange("description2", editor.getData())}/>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (1608 × 660)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.section_image}
                    />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Listing Image (444 × 332)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="image"
                    // maxSize={550 * 1024}
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.image}/>
                </div>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
